module.exports = __webpack_public_path__ + "img/gif4.c1098a0a.gif";